import { get } from 'lodash';
import { AxiosClient } from 'src/configs/axios/axios';

const MAIL_API = {
  mailConfigAPI: async () => {
    const response = await new AxiosClient().get('/mail-config')
    return get(response, 'data', null)
  },
  settingMailConfigAPI: async (params: Mail.SettingMailConfigParams) => {
    const response = await new AxiosClient().put(
      `/mail-config/setting/${params.id}`,
      params
    )
    const data = get(response, 'data', null)
    return data
  },
}

export default MAIL_API
